<template>
  <SimpleModuleDashboard
    :module-id="Modules.SENSORES"
    :profile-id="Profiles.CLIENTE"
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: {
    SimpleModuleDashboard,
  },
  data() {
    return {
      Modules,
      Profiles,
      dashboardActions: [
        {
          id: 'listSensorsTank',
          reference: 'listSensorsTank',
          route: 'SensorsCustomerListSensorsTank',
          tone: 'primary',
        },
      ],
    }
  },
}
</script>
